export interface ILoadingState {
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly actionConfirmedText?: boolean;
}

export type ILoadingSelector = ILoadingState

export enum LoadingActionTypes {
  LOADING_START = 'redux-app/loading/LOADING_START',
  LOADING_FINISH = 'redux-app/loading/LOADING_FINISH',
  ACTION_CONFIRMED = 'redux-app/loading/ACTION_CONFIRMED',
}

export default null;
